import { Injectable } from "@angular/core";
import { Currency } from "@models/interfaces/currency";
import { TradableListService } from "@main-services/currency/tradable_list.service";
import { FiatWalletService } from "@main-services/wallet/fiat_wallet.service";

@Injectable({
	providedIn: "root"
})
export class PathResolverService {
	constructor(
		private readonly tradableListService: TradableListService,
		private readonly fiatWalletService: FiatWalletService
	) {}

	public assetDetails(currency: Currency): string {
		return "/asset/" + currency.getId();
	}

	public assetDetailsById(id: string): string {
		return "/asset/" + id;
	}

	public assetDetailsByPid(pid: string): string {
		const id = this.tradableListService.getItemByPid(pid)?.getId();

		if (!id) {
			return "";
		}

		return this.assetDetailsById(id);
	}

	public portfolioGroup(groupId: string): string {
		return `/portfolio?type=${groupId}`;
	}

	public fiatWalletById(id: string): string {
		return `/fiat-wallet/${id}`;
	}

	public fiatWalletByFiatId(fiatId: string): string {
		const id = this.fiatWalletService.getWalletByFiatId(fiatId)?.getId();

		if (!id) {
			return "";
		}

		return this.fiatWalletById(id);
	}
}
